import React from "react";
import { Modal } from "antd";
import StripeCardFormContent from "./StripeCardFormContent";

interface StripeCardFormProps {
  visible: boolean;
  onClose: () => void;
}

const StripeCardForm: React.FC<StripeCardFormProps> = ({
  visible,
  onClose,
}) => {
  return (
    <>
      <Modal
        title="Bind credit card"
        open={visible}
        onCancel={onClose}
        footer={null}
        destroyOnClose
      >
        <StripeCardFormContent
          onClose={onClose}
        />
      </Modal>
    </>
  );
};

export default StripeCardForm;
